// /var/www/afra/web-design.rampagesoft.com/my-app/src/page/HomeIndex.js

import React, { useState, useEffect } from 'react';
import MetaTAG from '../meta-tag';
import BannerHome from '../component/BannerHome';
import Service from '../component/Service';
import HomeBusiness from '../component/HomeBusiness';
import '../css/HomeIndex.scss';
import Slidebar from "../component/slidebar.js";
import { fetchPosts, fetchPostImage } from '../services/api';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import homeIndexData from '../data/HomeIndex.json';

// Debug log เพื่อตรวจสอบ JSON
//console.log('homeIndexData:', homeIndexData);

// Swiper configurations สำหรับ Service
const serviceSwiperConfig = {
  modules: [Navigation, Autoplay],
  spaceBetween: 20,
  slidesPerView: 3,
  loop: true,
  navigation: true,
  className: "service-swiper-instance",
  breakpoints: {
    320: { slidesPerView: 1, spaceBetween: 10 },
    768: { slidesPerView: 2, spaceBetween: 15 },
    1024: { slidesPerView: 3, spaceBetween: 20 },
  },
  autoplay: { delay: 3000, disableOnInteraction: false },
};

// Swiper configurations สำหรับ ExamplesSlider (ใช้ใน HomeBusiness)
const examplesSwiperConfig = {
  modules: [Pagination, Autoplay],
  spaceBetween: 20,
  slidesPerView: 1,
  pagination: { clickable: true },
  autoplay: { delay: 3000, disableOnInteraction: false },
  loop: true,
  className: "examples-swiper-instance",
  breakpoints: {
    320: { slidesPerView: 1, spaceBetween: 10 },
    768: { slidesPerView: 1, spaceBetween: 20 },
    1024: { slidesPerView: 1, spaceBetween: 20 },
  },
  style: { width: '100%', height: 'auto' },
};

// ฟังก์ชันช่วยเหลือสำหรับลบ HTML tags
const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

// ฟังก์ชันช่วยเหลือสำหรับตัดข้อความ
const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// ฟังก์ชันช่วยเหลือสำหรับสร้าง URL-friendly string
const createUrlFriendlyString = (text) => {
  return encodeURIComponent(text)
    .replace(/%20/g, '-') // แทนที่ช่องว่างด้วยขีด
    .replace(/%[0-9A-F]{2}/g, match => {
      return match === '%2F' ? '/' : match;
    });
};

function HomeIndex() {
  // เพิ่มค่า default เพื่อป้องกัน undefined
  const { 
    id = 'hero-section', 
    title = 'Default Title', 
    text = 'Default Text', 
    cta = { id: 'default-cta', link: '#', text: 'Learn More' } 
  } = homeIndexData.hero || {};
  
  const [slidebarData, setSlidebarData] = useState([]);
  const [loading, setLoading] = useState(true);
  const heading = "CONTENT IDEAS LAB";
  const defaultImage = 'https://afaa.website/s/ff6970.png';

  useEffect(() => {
    async function fetchSlidebarData() {
      try {
        setLoading(true);
        const data = await fetchPosts(10);
        const posts = data.results || [];
        const formattedData = await Promise.all(
          posts
            .filter(post => post.Home_ID && post.Home_Sub)
            .map(async (post) => {
              if (!post.Home_ID) {
                console.warn('Post missing Home_ID:', post);
                return null;
              }
              let imgUrl = defaultImage;
              try {
                const imageData = await fetchPostImage(post.Home_ID);
                if (imageData.results && imageData.results.length > 0 && imageData.results[0].ImgHome_Img) {
                  imgUrl = imageData.results[0].ImgHome_Img;
                }
              } catch (error) {
                console.error(error.message);
              }

              const cleanedTitle = stripHtml(post.Home_Sub || 'Untitled');
              const truncatedTitle = truncateText(cleanedTitle, 50);
              const cleanedDescription = stripHtml(post.Home_Short || '');
              const truncatedDescription = truncateText(cleanedDescription, 200);
              const urlFriendlyName = createUrlFriendlyString(cleanedTitle);

              return {
                id: post.Home_ID,
                img: imgUrl,
                title: truncatedTitle,
                description: truncatedDescription,
                link: `/content/${post.Home_ID}/${urlFriendlyName}`,
                namelink: 'Read More',
                style: {
                  width: '100%',
                  height: 'auto',
                  padding: 0,
                  objectFit: 'cover'
                }
              };
            })
        );

        setSlidebarData(formattedData.filter(item => item !== null && item.img && item.img.startsWith('https')));
      } catch (error) {
        console.error('Failed to fetch Slidebar data:', error);
        setSlidebarData([]);
      } finally {
        setLoading(false);
      }
    }

    fetchSlidebarData();
  }, []);

  return (
    <>
      <MetaTAG />
      <BannerHome />
      <section id={id} className="hero-content">
        <h1>{title}</h1>
        <p>{text}</p>
        <div className="hero-cta">
          <a id={cta.id} href={cta.link} className="cta-button">
            {cta.text}
          </a>
        </div>
      </section>
      <Service
        Swiper={Swiper}
        SwiperSlide={SwiperSlide}
        swiperConfig={serviceSwiperConfig}
      />
      <HomeBusiness
        Swiper={Swiper}
        SwiperSlide={SwiperSlide}
        swiperConfig={examplesSwiperConfig}
      />
      {loading ? (
        <div className="progress-spinner">
          <div className="spinner"></div>
        </div>
      ) : (
        <Slidebar
          data={slidebarData}
          heading={heading}
          theme="primary-home"
        />
      )}
    </>
  );
}

export default HomeIndex;